<template>
    <transition
        name="el-drawer-fade"
        @after-enter="afterEnter"
        @after-leave="afterLeave"
    >
        <div class="el-drawer__wrapper" tabindex="-1" v-show="visible">
            <div
                class="el-drawer__container"
                :class="visible && 'el-drawer__open'"
                @click.self="handleWrapperClick"
                role="document"
                tabindex="-1"
            >
                <div
                    aria-modal="true"
                    aria-labelledby="el-drawer__title"
                    :aria-label="title"
                    class="el-drawer"
                    :class="[direction, customClass]"
                    :style="
                        isHorizontal
                            ? `width: ${drawerSize}`
                            : `height: ${drawerSize}`
                    "
                    ref="drawer"
                    role="dialog"
                    tabindex="-1"
                >
                    <header
                        class="el-drawer__header"
                        id="el-drawer__title"
                        v-if="title"
                    >
                        <slot name="title">
                            <span role="heading" :title="title">{{
                                title
                            }}</span>
                        </slot>
                    </header>
                    <section class="el-drawer__body" v-if="visible">
                        <!-- 关闭按钮 -->
                        <div class="dialogs-close" v-if="showClose" @click="closeDrawer">
                            <img :src="closeImg" alt="">
                        </div>
                        <div v-if="$slots.default" class="drawer-contain" :class="{ 'havefooter': $slots.footer || footer }">
                            <slot></slot>
                        </div>
                        <div class="drawer-footer" v-if="$slots.footer">
                            <slot name="footer"></slot>
                        </div>
                        <div class="drawer-footer" v-else-if="footer">
                            <el-button @click="closeDrawer" v-if="cancelShow">{{cancelText}}</el-button>
                            <el-button type="primary" :loading="confirmLoading" @click="confirm" v-if="confirmShow">{{confirmText}}</el-button>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Popup from "element-ui/src/utils/popup";
import emitter from "element-ui/src/mixins/emitter";
import elementResizeDetectorMaker from 'element-resize-detector';
import closeImg from '@imgs/drawer_close_icon.png';

export default {
    name: "JdDrawer",
    mixins: [Popup, emitter],
    model: {
        prop: "visible",
        event: "change",
    },
    props: {
        // 指定挂载节点
        appendTo: {
            type: String,
            default: ''
        },
        // 底部栏
        footer: {
            type: Boolean,
            default: false
        },
        // 确认按钮
        confirmShow: {
            type: Boolean,
            default: true
        },
        // 确认按钮loading
        confirmLoading: {
            type: Boolean,
            default: false
        },
        // 确认按钮文字
        confirmText: {
            type: String,
            default: '确定'
        },
        // 取消按钮
        cancelShow: {
            type: Boolean,
            default: true
        },
        // 取消按钮文字
        cancelText: {
            type: String,
            default: '取消'
        },
        type: {
            type: [String, Number],
            default: 0
        },
        position: {
            type: String,
            default: "fixed",
        },
        width: {
            type: String,
            default: "",
        },
        height: {
            type: String,
            default: "",
        },
        top: {
            type: String,
            default: "0",
        },
        left: {
            type: String,
            default: "unset",
        },
        right: {
            type: String,
            default: "0",
        },
        bottom: {
            type: String,
            default: "0",
        },
        appendToBody: {
            type: Boolean,
            default: false,
        },
        beforeClose: {
            type: Function,
        },
        customClass: {
            type: String,
            default: "",
        },
        closeOnPressEscape: {
            type: Boolean,
            default: true,
        },
        destroyOnClose: {
            type: Boolean,
            default: false,
        },
        modal: {
            type: Boolean,
            default: false,
        },
        direction: {
            type: String,
            default: "rtl",
            validator(val) {
                return ["ltr", "rtl", "ttb", "btt"].indexOf(val) !== -1;
            },
        },
        modalAppendToBody: {
            type: Boolean,
            default: false,
        },
        showClose: {
            type: Boolean,
            default: true,
        },
        size: {
            type: [Number, String],
            default: "100%",
        },
        title: {
            type: String,
            default: "",
        },
        visible: {
            type: Boolean,
        },
        wrapperClosable: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        isHorizontal() {
            return this.direction === "rtl" || this.direction === "ltr";
        },
        drawerSize() {
            let res = typeof this.size === "number" ? `${this.size}px` : this.size;
            switch (+this.type) {
                case 0:
                    res = '100%';
                    break;
                case 1:
                    res = '650px';
                    break;
                default:
                    break;
            }
            return res;
        },
    },
    data() {
        return {
            closeImg,
            closed: false,
            prevActiveElement: null,
        };
    },
    watch: {
        visible(val) {
            if (val) {
                this.closed = false;
                this.$emit("open");
                if (this.appendTo) {
                    document.querySelector(this.appendTo).appendChild(this.$el);
                } else if (this.appendToBody) {
                    document.body.appendChild(this.$el);
                }
                this.prevActiveElement = document.activeElement;
            } else {
                if (!this.closed) this.$emit("close");
                this.$nextTick(() => {
                    if (this.prevActiveElement) {
                        this.prevActiveElement.focus();
                    }
                });
            }
        },
    },
    methods: {
        // 点击确认
        confirm() {
            this.$emit('confirm');
        },
        afterEnter() {
            this.$emit("opened");
        },
        afterLeave() {
            this.$emit("closed");
        },
        hide(cancel) {
            if (cancel !== false) {
                this.$emit("change", false);
                this.$emit("update:visible", false);
                this.$emit("close");
                this.closed = true;
            }
        },
        handleWrapperClick() {
            if (this.wrapperClosable) {
                this.closeDrawer();
            }
        },
        closeDrawer() {
            if (typeof this.beforeClose === "function") {
                this.beforeClose(this.hide);
            } else {
                this.hide();
            }
        },
        handleClose() {
            // This method here will be called by PopupManger, when the `closeOnPressEscape` was set to true
            // pressing `ESC` will call this method, and also close the drawer.
            // This method also calls `beforeClose` if there was one.
            this.closeDrawer();
        },
        /**
         * 监听父级dom宽度变化
         */
        listenFather() {
            this.$nextTick(() => {
                const erd = elementResizeDetectorMaker();
                const parent = this.$el.parentNode;
                erd.listenTo(parent, ele => {
                const w = ele.offsetWidth;
                this.$el.style.width = this.width ? this.width : `${w}px`;
                });
            });
        },
    },
    mounted() {
        this.listenFather();
        this.$el.style.position = this.position;
        this.$el.style.top = this.top;
        this.$el.style.left = this.left;
        this.$el.style.right = this.right;
        this.$el.style.bottom = this.bottom;
        this.$el.style.height = this.height ? this.height : `calc(100% - (${this.top} + ${this.bottom}))`;
        if (this.visible) {
            this.open();
        }
    },
    destroyed() {
        // if appendToBody is true, remove DOM node after destroy
        if ((this.appendToBody || this.appendTo) && this.$el && this.$el.parentNode) {
            this.$el.parentNode.removeChild(this.$el);
        }
    },
};
</script>

<style lang="scss" scoped>
.drawer-contain {
    height: 100%;
    overflow-y: auto;
}
.havefooter {
    height: calc(100% - 70px);
}
.drawer-footer {
    width: 100%;
    height: 70px;
    box-sizing: border-box;
    padding: 0 30px;
    background: #FFFFFF;
    box-shadow: 0px -6px 6px 0px rgba(15, 19, 77, 0.02);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    ::v-deep .el-button {
        min-width: 100px;
        + .el-button {
            margin-left: 10px;
        }
    }
}
.dialogs-close {
    width: 16px;
    height: 16px;
    cursor: pointer;
    position: absolute;
    right: 30px;
    top: 16px;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
        opacity: .8;
    }
    img {
        width: 100%;
        height: 100%;
    }
}
::v-deep .el-drawer {
    .el-drawer__header {
        // border-bottom: 1px solid #e4e4e4;
        height: 50px;
        box-sizing: border-box;
        margin: 0;
        display: flex;
        align-items: center;
        width: 100%;
        padding: 0 30px;
        position: relative;
        & > span {
            color: #333;
            line-height: 50px;
            font-weight: bold;
            font-size: 16px;
        }
        .el-drawer__close-btn {
            position: absolute;
            top: 20px;
            right: 20px;
            font-size: 16px;
            padding: 0;
        }
    }
}
::v-deep .el-drawer__body {
    overflow-y: auto;
}
</style>
